var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMasterCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "22px",
    viewBox: "0 0 34 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "master-cart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Checkout-Cart-(USA)-Tarjeta-de-Pago",
    transform: "translate(-773.000000, -773.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "master-cart",
    transform: "translate(773.000000, 773.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#FF5F00",
    points: "12.4032285 18.7685402 21.5964691 18.7685402 21.5964691 2.24725853 12.4032285 2.24725853"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9874568,10.5074286 C12.9846322,7.28358016 14.4647402,4.23768365 17.0003196,2.24725853 C12.4385364,-1.33908453 5.83266006,-0.548187138 2.24725853,4.01453759 C-1.33908453,8.57632078 -0.548187138,15.1821971 4.01453759,18.7675986 C7.82496826,21.7635933 13.1898889,21.7635933 17.0003196,18.7675986 C14.4647402,16.7771735 12.9846322,13.731277 12.9874568,10.5074286",
    id: "Fill-2",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,10.5074286 C34,16.3101674 29.2960436,21.0141239 23.4942463,21.0141239 C21.1385019,21.0141239 18.8524318,20.2232265 17.0004137,18.7675986 C21.5631385,15.180314 22.3530943,8.57443769 18.7658097,4.01171296 C18.2498433,3.35545643 17.6566703,2.76322493 17.0004137,2.24725853 C21.5621969,-1.33908453 28.1680733,-0.548187138 31.7534748,4.01453759 C33.2091026,5.86561412 34,8.15262575 34,10.5074286",
    id: "Fill-4",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7521557,17.0551474 L33.7521557,16.6105202 L33.6361213,16.6105202 L33.5026305,16.9165223 L33.3691396,16.6105202 L33.2531052,16.6105202 L33.2531052,17.0551474 L33.3342266,17.0551474 L33.3342266,16.7193666 L33.4595027,17.0089391 L33.5447314,17.0089391 L33.6700075,16.7193666 L33.6700075,17.0551474 L33.7521557,17.0551474 Z M33.0169291,17.0551474 L33.0169291,16.6865073 L33.1658227,16.6865073 L33.1658227,16.611547 L32.786914,16.611547 L32.786914,16.6865073 L32.9358077,16.6865073 L32.9358077,17.0551474 L33.0169291,17.0551474 Z",
    id: "Fill-6",
    fill: "#F79E1B"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCart);
export default __webpack_public_path__ + "static/media/master-cart.040f0cf6e417e4ed94fbc4226b3d85fd.svg";
export { ForwardRef as ReactComponent };